/**
 * 监听页面是否可见
 */
import { useEffect } from 'react';

const useVisibilityChange = (onVisible: () => void, onHidden: () => void) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        onVisible();
      } else {
        onHidden();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [onVisible, onHidden]);
};

export default useVisibilityChange;
